import { useMemo } from 'react'
import useOrderFrequency from '../frequency/use-order-frequency'
import useOrderRecurringEndDate from '../recurring-end-date/use-order-recurring-end-date'
import useOrderAmount from '../amount/use-order-amount'
import useOrderCurrency from '../currency/use-order-currency'
import useOrderAddress from '../address/use-address'
import useOrderContact from '../contact/use-contact'
import useOrderComment from '../comment/use-order-comment'
import useOrderDedication from '../dedication/use-order-dedication'
import useOrderDesignation from '../designation/use-order-designation'
import useOrderDoubleTheDonation from '../double-the-donation/use-order-double-the-donation'
import useOrderDonorCoveredFees from '../dcf/use-order-donor-covered-fees'
import useOrderContactAnswers from '../contact-answers/use-contact-answers'
import useOrderCustomAnswers from '../custom-answers/use-custom-answers'
import usePaymentDetails from '../payment-details/use-payment-details'
import useNudgeTracking from '../nudge-tracking/use-nudge-tracking'

const useOrder = () => {
  const frequency = useOrderFrequency()
  const recurringEndDate = useOrderRecurringEndDate()
  const amount = useOrderAmount()
  const currency = useOrderCurrency()
  const address = useOrderAddress()
  const contact = useOrderContact()
  const contactAnswers = useOrderContactAnswers()
  const customAnswers = useOrderCustomAnswers()
  const comment = useOrderComment()
  const dedication = useOrderDedication()
  const designation = useOrderDesignation()
  const doubleTheDonation = useOrderDoubleTheDonation()
  const dcf = useOrderDonorCoveredFees()
  const paymentDetails = usePaymentDetails()
  const nudgeTracking = useNudgeTracking()

  return useMemo(
    () => ({
      frequency,
      recurringEndDate,
      amount,
      currency,
      address,
      contact,
      contactAnswers,
      customAnswers,
      comment,
      dedication,
      designation,
      doubleTheDonation,
      dcf,
      paymentDetails,
      nudgeTracking,
    }),
    [
      frequency,
      recurringEndDate,
      amount,
      currency,
      address,
      contact,
      contactAnswers,
      customAnswers,
      comment,
      dedication,
      designation,
      doubleTheDonation,
      dcf,
      paymentDetails,
      nudgeTracking,
    ],
  )
}

export default useOrder
